import React from 'react';
import Card from '../../ui/Card';
import { TrendingUpIcon, TrendingDownIcon } from 'lucide-react';
const DealerPerformanceTable: React.FC = () => {
  const dealerData = [{
    dealer: 'Metro Auto Parts (Mumbai)',
    state: 'Maharashtra',
    revenue: 18.5,
    growth: 15.2,
    sellOut: 92,
    collection: 88,
    satisfaction: 8.8,
    returnRate: 1.8,
    kpiScore: 92,
    tier: 'Platinum'
  }, {
    dealer: 'Speed Motors (Ahmedabad)',
    state: 'Gujarat',
    revenue: 16.2,
    growth: 12.8,
    sellOut: 90,
    collection: 85,
    satisfaction: 8.5,
    returnRate: 2.2,
    kpiScore: 89,
    tier: 'Platinum'
  }, {
    dealer: 'Prime Distributors (Chennai)',
    state: 'Tamil Nadu',
    revenue: 14.8,
    growth: 10.5,
    sellOut: 88,
    collection: 82,
    satisfaction: 8.2,
    returnRate: 2.5,
    kpiScore: 85,
    tier: 'Gold'
  }, {
    dealer: 'City Auto Zone (Bangalore)',
    state: 'Karnataka',
    revenue: 13.5,
    growth: 11.8,
    sellOut: 85,
    collection: 80,
    satisfaction: 8.0,
    returnRate: 2.8,
    kpiScore: 82,
    tier: 'Gold'
  }, {
    dealer: 'Express Parts (Delhi)',
    state: 'Delhi NCR',
    revenue: 12.8,
    growth: 14.2,
    sellOut: 87,
    collection: 83,
    satisfaction: 8.3,
    returnRate: 2.4,
    kpiScore: 86,
    tier: 'Gold'
  }, {
    dealer: 'Quick Service (Pune)',
    state: 'Maharashtra',
    revenue: 11.5,
    growth: 9.5,
    sellOut: 82,
    collection: 78,
    satisfaction: 7.8,
    returnRate: 3.2,
    kpiScore: 78,
    tier: 'Gold'
  }, {
    dealer: 'Auto Hub (Hyderabad)',
    state: 'Telangana',
    revenue: 10.2,
    growth: 8.8,
    sellOut: 80,
    collection: 75,
    satisfaction: 7.5,
    returnRate: 3.5,
    kpiScore: 75,
    tier: 'Silver'
  }, {
    dealer: 'Local Motors (Jaipur)',
    state: 'Rajasthan',
    revenue: 9.5,
    growth: 7.2,
    sellOut: 78,
    collection: 72,
    satisfaction: 7.2,
    returnRate: 3.8,
    kpiScore: 72,
    tier: 'Silver'
  }, {
    dealer: 'Budget Parts (Lucknow)',
    state: 'Uttar Pradesh',
    revenue: 8.8,
    growth: 6.5,
    sellOut: 75,
    collection: 70,
    satisfaction: 7.0,
    returnRate: 4.2,
    kpiScore: 68,
    tier: 'Silver'
  }, {
    dealer: 'Value Auto (Kolkata)',
    state: 'West Bengal',
    revenue: 8.2,
    growth: 5.8,
    sellOut: 72,
    collection: 68,
    satisfaction: 6.8,
    returnRate: 4.5,
    kpiScore: 65,
    tier: 'Bronze'
  }];
  const getTierColor = (tier: string) => {
    switch (tier) {
      case 'Platinum':
        return 'bg-purple-100 text-purple-800 border-purple-300';
      case 'Gold':
        return 'bg-yellow-100 text-yellow-800 border-yellow-300';
      case 'Silver':
        return 'bg-gray-100 text-gray-800 border-gray-300';
      case 'Bronze':
        return 'bg-orange-100 text-orange-800 border-orange-300';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-300';
    }
  };
  const getKPIScoreColor = (score: number) => {
    if (score >= 85) return 'text-green-600 font-bold';
    if (score >= 75) return 'text-yellow-600 font-semibold';
    if (score >= 65) return 'text-orange-600';
    return 'text-red-600';
  };
  const getMetricColor = (value: number, threshold: number, inverse = false) => {
    if (inverse) {
      return value <= threshold ? 'text-green-600' : 'text-red-600';
    }
    return value >= threshold ? 'text-green-600' : 'text-red-600';
  };
  return <Card className="p-6" data-id="element-7154">
      <div className="flex items-center justify-between mb-4" data-id="element-7155">
        <div data-id="element-7156">
          <h3 className="text-lg font-semibold text-gray-800" data-id="element-7157">
            Dealer Performance Scorecard
          </h3>
          <p className="text-sm text-gray-600" data-id="element-7158">
            Comprehensive KPI tracking for top dealers
          </p>
        </div>
        <div className="text-right" data-id="element-7159">
          <div className="text-sm text-gray-600" data-id="element-7160">Total Dealers</div>
          <div className="text-2xl font-bold text-gray-900" data-id="element-7161">534</div>
        </div>
      </div>
      <div className="overflow-x-auto" data-id="element-7162">
        <table className="w-full" data-id="element-7163">
          <thead data-id="element-7164">
            <tr className="border-b-2 border-gray-300" data-id="element-7165">
              <th className="text-left py-3 px-4 text-sm font-bold text-gray-700" data-id="element-7166">
                Dealer Name
              </th>
              <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-7167">
                State
              </th>
              <th className="text-right py-3 px-4 text-sm font-bold text-gray-700" data-id="element-7168">
                Revenue
              </th>
              <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-7169">
                Growth %
              </th>
              <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-7170">
                Sell-out %
              </th>
              <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-7171">
                Collection %
              </th>
              <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-7172">
                Satisfaction
              </th>
              <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-7173">
                Return %
              </th>
              <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-7174">
                KPI Score
              </th>
              <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-7175">
                Tier
              </th>
            </tr>
          </thead>
          <tbody data-id="element-7176">
            {dealerData.map((dealer, index) => <tr key={index} className="border-b border-gray-100 hover:bg-gray-50" data-id="element-7177">
                <td className="py-3 px-4 text-sm font-medium text-gray-800" data-id="element-7178">
                  {dealer.dealer}
                </td>
                <td className="py-3 px-4 text-sm text-center text-gray-700" data-id="element-7179">
                  {dealer.state}
                </td>
                <td className="py-3 px-4 text-sm text-right font-semibold text-gray-900" data-id="element-7180">
                  ₹{dealer.revenue} Cr
                </td>
                <td className="py-3 px-4 text-center" data-id="element-7181">
                  <div className="flex items-center justify-center" data-id="element-7182">
                    <span className={`text-sm font-semibold ${getMetricColor(dealer.growth, 8)}`} data-id="element-7183">
                      {dealer.growth >= 0 ? '+' : ''}
                      {dealer.growth}%
                    </span>
                    {dealer.growth >= 8 ? <TrendingUpIcon size={14} className="ml-1 text-green-600" data-id="element-7184" /> : <TrendingDownIcon size={14} className="ml-1 text-red-600" data-id="element-7185" />}
                  </div>
                </td>
                <td className="py-3 px-4 text-center" data-id="element-7186">
                  <span className={`text-sm font-semibold ${getMetricColor(dealer.sellOut, 85)}`} data-id="element-7187">
                    {dealer.sellOut}%
                  </span>
                </td>
                <td className="py-3 px-4 text-center" data-id="element-7188">
                  <span className={`text-sm font-semibold ${getMetricColor(dealer.collection, 80)}`} data-id="element-7189">
                    {dealer.collection}%
                  </span>
                </td>
                <td className="py-3 px-4 text-center" data-id="element-7190">
                  <span className={`text-sm font-semibold ${getMetricColor(dealer.satisfaction, 8)}`} data-id="element-7191">
                    {dealer.satisfaction}/10
                  </span>
                </td>
                <td className="py-3 px-4 text-center" data-id="element-7192">
                  <span className={`text-sm font-semibold ${getMetricColor(dealer.returnRate, 3, true)}`} data-id="element-7193">
                    {dealer.returnRate}%
                  </span>
                </td>
                <td className="py-3 px-4 text-center" data-id="element-7194">
                  <span className={`text-lg ${getKPIScoreColor(dealer.kpiScore)}`} data-id="element-7195">
                    {dealer.kpiScore}
                  </span>
                </td>
                <td className="py-3 px-4 text-center" data-id="element-7196">
                  <span className={`inline-flex px-3 py-1 rounded-full text-xs font-bold border ${getTierColor(dealer.tier)}`} data-id="element-7197">
                    {dealer.tier}
                  </span>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
      <div className="mt-6 pt-6 border-t border-gray-200" data-id="element-7198">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4" data-id="element-7199">
          <div className="text-center" data-id="element-7200">
            <div className="text-xs text-gray-600 mb-1" data-id="element-7201">Avg Revenue</div>
            <div className="text-xl font-bold text-gray-900" data-id="element-7202">₹12.4 Cr</div>
          </div>
          <div className="text-center" data-id="element-7203">
            <div className="text-xs text-gray-600 mb-1" data-id="element-7204">Avg Growth</div>
            <div className="text-xl font-bold text-green-600" data-id="element-7205">10.2%</div>
          </div>
          <div className="text-center" data-id="element-7206">
            <div className="text-xs text-gray-600 mb-1" data-id="element-7207">Avg Sell-out</div>
            <div className="text-xl font-bold text-blue-600" data-id="element-7208">82.9%</div>
          </div>
          <div className="text-center" data-id="element-7209">
            <div className="text-xs text-gray-600 mb-1" data-id="element-7210">Avg Collection</div>
            <div className="text-xl font-bold text-purple-600" data-id="element-7211">78.1%</div>
          </div>
          <div className="text-center" data-id="element-7212">
            <div className="text-xs text-gray-600 mb-1" data-id="element-7213">Avg KPI Score</div>
            <div className="text-xl font-bold text-yellow-600" data-id="element-7214">79.2</div>
          </div>
        </div>
      </div>
      <div className="mt-4 pt-4 border-t border-gray-100" data-id="element-7215">
        <div className="flex items-center justify-between text-xs" data-id="element-7216">
          <span className="text-gray-600" data-id="element-7217">Dealer Tier Distribution:</span>
          <div className="flex items-center space-x-4" data-id="element-7218">
            <div className="flex items-center" data-id="element-7219">
              <div className="w-3 h-3 rounded bg-purple-500 mr-1" data-id="element-7220" />
              <span className="text-gray-600" data-id="element-7221">Platinum: 2</span>
            </div>
            <div className="flex items-center" data-id="element-7222">
              <div className="w-3 h-3 rounded bg-yellow-500 mr-1" data-id="element-7223" />
              <span className="text-gray-600" data-id="element-7224">Gold: 4</span>
            </div>
            <div className="flex items-center" data-id="element-7225">
              <div className="w-3 h-3 rounded bg-gray-400 mr-1" data-id="element-7226" />
              <span className="text-gray-600" data-id="element-7227">Silver: 3</span>
            </div>
            <div className="flex items-center" data-id="element-7228">
              <div className="w-3 h-3 rounded bg-orange-500 mr-1" data-id="element-7229" />
              <span className="text-gray-600" data-id="element-7230">Bronze: 1</span>
            </div>
          </div>
        </div>
      </div>
    </Card>;
};
export default DealerPerformanceTable;